import React, { useContext, useEffect, useState } from 'react'
import { store } from '../../stores/pages'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CloseButton from '../shared/CloseButton'

export default function UpdatePublishedModal({ isOpen, close }) {
  const { saving, dispatch, actions } = useContext(store)


  const savePage = () => {
    dispatch({ type: actions.SAVE_PAGE })
  }

  return (
    <Modal isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close} close={<CloseButton onClick={close} />} tag="h3">
        Update this Published Page?
      </ModalHeader>
      <ModalBody>
        <p>Updating a published page <strong>can take up to 1 minute</strong> to take effect after the request is made. Thank you for your patience!</p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={savePage} disabled={saving}>
          {saving ? 'Updating...' : 'Update Published Page'}
        </Button>
        <Button color="outline-secondary" onClick={close}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
